global.jQuery = require('jquery');
require('jquery.caret');
var Marionette = require('backbone.marionette');
var wysiwyg = require('wysiwyg.js');
var format4pdf = require('app/utils/format4pdf');

var TextEditor = Marionette.ItemView.extend({
    template: false,
    ui: {
        input: 'input:first',
        bold: '[data-ui="bold"]',
        italic: '[data-ui="italic"]',
        editorBody: '[data-ui="editorBody"]',
    },
    events: {
        'click @ui.bold': 'embolden',
        'click @ui.italic': 'italicize',
        'keydown @ui.editorBody': 'updateInput',
    },
    initialize: function() {
        this.bindUIElements();
    },
    onRender: function() {
        this.editor = wysiwyg({
            element: this.ui.editorBody.get(0),
            onKeyUp: this.updateInput.bind(this),
        });
    },
    embolden: function() {
        this.editor.bold();
        this.updateInput();
        return false;
    },
    italicize: function() {
        this.editor.italic();
        this.updateInput();
        return false;
    },
    onDeserialize: function(val) {
        val = val || '';
        // format output or insert empty paragraph to make sure editor formats things with paragraphs
        var formatted = this.sanitizeOutput(this.nl2p(val)) || '<p><br /></p>';
        this.editor.setHTML(formatted);
        this.ui.input.val(formatted);
    },
    sanitizeOutput: function(raw) {
        var output = format4pdf(raw, ['p', 'br', 'i', 'em', 'strong', 'b']);
        return output;
    },
    updateInput: function() {
        setTimeout(
            function() {
                var raw = this.editor.getHTML();
                var oldCaretPos = this.ui.editorBody.caret('pos');
                var sanitized = this.sanitizeOutput(raw);
                if (sanitized != this.ui.input.val()) {
                    this.ui.input.val(sanitized).change();
                    this.editor.setHTML(sanitized);
                    if (oldCaretPos == this.ui.editorBody.text().length) {
                        this.placeCaretAtEnd();
                    } else {
                        this.ui.editorBody.caret('pos', oldCaretPos);
                    }
                }
            }.bind(this),
            1
        );
    },
    nl2p: function(text) {
        var split = text.split(/(?:\r\n|\r|\n)/g);
        return split.reduce(function(memo, chunk) {
            if (chunk) {
                memo += '<p>' + chunk + '</p>';
            }
            return memo;
        });
    },
    placeCaretAtEnd: function() {
        var node = this.ui.editorBody
            .children()
            .last()
            .get(0);
        var range = document.createRange();
        range.selectNodeContents(node);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    },
});

module.exports = TextEditor;
